module.exports = __webpack_public_path__ + "img/placeholder-mesi.e2fe463c.svg";